
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { ActivitiesSource } from "src/store/activity/types";
import { getAllTagTableAPI,getTagByIdAPI,postRegisterTagAPI,putUpdateTagAPI} from "./restCallTag";
import {Tag} from "./types";

export const getAllTagTable = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllTagTableAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getTagById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getTagByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postRegisterTag = (value:Tag): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postRegisterTagAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putUpdateTag = (value:Tag): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putUpdateTagAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};